import React from 'react';
import { SkeletonTable } from '../../../components/Skeleton/Table';

const Loading: React.FC<React.PropsWithChildren<unknown>> = () => (
  <SkeletonTable className="card-table" columns={6} rows={15} />
);

export default Loading;
